<template>
    <div class="internal-resources-root">
        <Header :label="$t('resourcesInternal.header')" overlap="small" />
        <UserNavSection />
        <MainLayout marginTop>
            <ProfileModule slot="right" />
            <FeaturedResource slot="right" />
            <VerifyModule slot="right" />
            <SectionHeader slot="center" style="position:relative">
                <Breadcrumb :trace="breadcrumb" slot="left"
            /></SectionHeader>
            <ResourcesFolderGrid v-if="hasItems" slot="center" :files="files" />
            <NoContent
                v-else
                slot="center"
                :caption="$t('resourcesInternal.resourceNoContent')"
            ></NoContent>
        </MainLayout>
    </div>
</template>

<script>
// Components
import Header from '~/components/layouts/Header';
import MainLayout from '~/components/layouts/mainlayout/MainLayout';
import UserNavSection from '~/shared/UserNavSection';
import ProfileModule from '~/components/smart/ProfileModule/ProfileModule';
import VerifyModule from '~/components/miscellaneous/VerifyModule';
import NoContent from '~/components/miscellaneous/NoContent';
import FeaturedResource from '~/components/smart/FeaturedResource';
// import SearchBar from '../../../shared/searchmodule/SearchBar';
// import ResourcesSearchBar from './components/ResourcesSearchBar';
// import ResourcesFolderCard from './components/ResourcesFolderCard';
import ResourcesFolderGrid from './components/ResourcesFolderGrid';
import Breadcrumb from '../../../shared/Breadcrumb';
import ResourceService from '~/services/ResourceService';
import SectionHeader from '~/components/layouts/SectionHeader';
import URLS from '~/URLS';
import i18n from '~/i18n';

import EmptySvg from '~/assets/img/empty.svg';

export default {
    name: 'ResourcesInternal',
    components: {
        Breadcrumb,
        ResourcesFolderGrid,
        // ResourcesFolderCard,
        // ResourcesSearchBar,
        // SearchBar,
        Header,
        UserNavSection,
        MainLayout,
        ProfileModule,
        VerifyModule,
        FeaturedResource,
        SectionHeader,
        NoContent,
    },
    data: () => ({
        search: '',
        breadcrumb: [
            {
                exact: true,
                text: i18n.t('resourcesInternal.header'),
                to: URLS.internalResources,
            },
        ],
        files: [],
    }),
    computed: {
        hasItems() {
            return this.files && this.files.filter(f => f.parent).length > 0;
        },
    },
    methods: {
        update() {
            return null;
        },
    },
    mounted() {
        ResourceService.getResources().then(res => {
            this.files = res;
        });
    },
};
</script>

<style scoped>
.internal-resources-root {
    padding-bottom: 100px;
}
.internal-resources-top-bar {
    padding: 20px;
}
</style>
